module.exports = __webpack_public_path__ + "img/pay-certification.75504ed1.png";